import defineProperty from './_define_property';
function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
defineProperty(Array, 'unique', function () {
  return this.filter(onlyUnique);
});